import { render, staticRenderFns } from "./VocalInstrumentsBadgeList.vue?vue&type=template&id=630e465e&scoped=true&"
import script from "./VocalInstrumentsBadgeList.vue?vue&type=script&lang=js&"
export * from "./VocalInstrumentsBadgeList.vue?vue&type=script&lang=js&"
import style0 from "./VocalInstrumentsBadgeList.vue?vue&type=style&index=0&id=630e465e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630e465e",
  null
  
)

export default component.exports